import React from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";
import { ChevronRightIcon } from "src/components/form-control-label/components/chevron-right-icon";
import { toCurrency } from "src/utils/formatter";
import { stringDateFullDynamicFormat } from "src/utils/date";
import { ISales } from "src/domains";
import { colors } from "src/assets";
import LocalText from "src/local";

export type SaleRowProps = ISales & {
  onPress?: () => void;
};

export const SaleRow: React.FC<SaleRowProps> = ({
  type,
  createdAt,
  request,
  amount,
  onPress,
}) => {
  return (
    <React.Fragment>
      {type === "SALES" ? (
        <View style={[styles.container]}>
          <Text style={[styles.date]}>
            {stringDateFullDynamicFormat(createdAt)}
          </Text>
          <View style={styles.content}>
            <Text style={[styles.title]}>{request?.service?.title}</Text>
            <View style={styles.rightContainer}>
              {amount ? (
                <Text style={[styles.amount]}>￥{toCurrency(amount)}</Text>
              ) : undefined}
            </View>
          </View>
        </View>
      ) : (
        <TouchableOpacity style={[styles.container]} onPress={onPress}>
          <Text style={[styles.date]}>
            {stringDateFullDynamicFormat(createdAt)}
          </Text>
          <View style={styles.content}>
            <Text style={[styles.title]}>
              {type === "WITHDRAWAL_REQUEST"
                ? LocalText.screens.salesHistory.saleRow.withdrawalRequest
                : null}
              {type === "WITHDRAWAL_PROCESSING"
                ? LocalText.screens.salesHistory.saleRow.withdrawalProcessing
                : null}
              {type === "WITHDRAWAL_APPROVED"
                ? LocalText.screens.salesHistory.saleRow.withdrawalApproved
                : null}
              {type === "WITHDRAWAL_ERROR"
                ? LocalText.screens.salesHistory.saleRow.withdrawalError
                : null}
              {type === "WITHDRAWAL_REJECTED"
                ? LocalText.screens.salesHistory.saleRow.withdrawalReject
                : null}
            </Text>
            <View style={styles.rightContainer}>
              {amount ? (
                <Text style={[styles.amount]}>￥{toCurrency(amount)}</Text>
              ) : undefined}
            </View>
            <ChevronRightIcon style={styles.rightIcon} />
          </View>
        </TouchableOpacity>
      )}
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: colors.white,
    flexDirection: "column",
    borderBottomColor: colors.gray1,
    borderBottomWidth: 1,
  },
  content: {
    flexDirection: "row",
    justifyContent: "flex-start",

    flexWrap: "nowrap",
  },
  date: {
    color: "#818181",
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 4,
  },
  title: {
    flex: 1,
    color: colors.chokuBlack,
    fontSize: 12,
    fontWeight: "500",
    marginRight: 16,
    paddingTop: 2,
  },
  rightContainer: {
    // flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    // alignItems: 'center',
  },
  amount: {
    color: colors.chokyGray10,
    fontWeight: "bold",
    fontSize: 12,
  },
  rightIcon: {
    marginLeft: 8,
    marginTop: 2,
  },
});
